import { Check, PriorityHigh } from "@mui/icons-material";
import { Badge, Box, Button, Grid } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { LabelingDialog } from "e.sic-platform.webclient/src/components/labeling/LabelingDialog";
import { useCallback, useState } from "react";
import { videoPlayerService } from "e.sic-platform.webclient/src/services/video-player/VideoPlayerService";
import { Rect, RectType } from "e.sic-platform.webclient/src/models/Rect";
import { OcrService } from "e.sic-platform.webclient/src/services/ocr/OcrService";

const OcrInputButton = observer(function OcrInputButton(props: {onClick(): void, done: boolean, textKey: string}) {
    const {done, onClick, textKey} = props;
    return (
        <Badge badgeContent={done ? <Check /> : <PriorityHigh />} color={done ? "success" : "error"}>
            <Button variant="contained" color="primary" onClick={onClick}>
                {translationService.translate(textKey)}
            </Button>
        </Badge>
    )
})

export default observer(function OcrInputs(props:{ocrService: OcrService}) {
    const {ocrService} = props;
    const[rects,setRects]=useState<Map<RectType, Rect>>(new Map());
    const[rectTypes,setRectTypes]=useState<RectType[]>([]);

    const takeScreenshot = useCallback(async() => {
        await videoPlayerService.takeScreenshotAtCurrentVideoPosition(ocrService.fileId!);
        ocrService.setScreenshotUrl(videoPlayerService.lastScreenshotUri);
    }, [ocrService.fileId]);
    
    const handleOpenDialog = async (rectTypes: RectType[]) => {
        await takeScreenshot();
        setRectTypes(rectTypes);
        setRects(ocrService.getRects(rectTypes))
      };
    
    const handleCloseDialog = () => {
        setRectTypes([])
        setRects(new Map())
    };
    const handleComplete = () => {
        if(rectTypes.length!=0){
            ocrService.setDialogScreenshot(rectTypes, ocrService.screenshot);
            ocrService.setDialogCoordinates(rectTypes, rects);
            ocrService.setDialogTimestamp(rectTypes, videoPlayerService.videoProgress);
        }
        setRects(new Map())
        setRectTypes([])
    };

    return (
        <>
            <Grid item xs={6} className="centered">
                <OcrInputButton textKey="ocrService.textArea.type.main" onClick={() => handleOpenDialog(["main"])} done={ocrService.mainInfoDone} />
            </Grid>
            <Grid item xs={6} className="centered">
                <OcrInputButton textKey="ocrService.textArea.type.detectionsDistance" onClick={() => handleOpenDialog(["detections","distance"])} done={ocrService.detectionsDistanceDone} />
            </Grid>
            <LabelingDialog
                isVisible={rectTypes.length!=0}
                rectTypes={rectTypes}
                onClose={handleCloseDialog}
                onComplete={handleComplete}
                screenshot={ocrService.screenshot}
                rects={rects}
                setRects={setRects}
            />
        </>
    )
})